import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../../../store/selector";
import {useTranslation} from "react-i18next";
import {message} from "antd";
import {axiosConfigOld} from "../../../../../utils/axios";
import {fetchSetSpecialityStatusAction} from "../../../../../store/pages/admission/actions";
import {IconKey} from "../../../../../assets";
import {StyledButton} from "../../../../../pages/Entrant/AdmissionWithoutRanking/index.styles";

export const EdsButton = ({
                            dataForXml,
                            keyType,
                            tplName,
                            tplData,
                            disabled,
                            edsResultHandler,
                            handleStart,
                            handleStop,
                            setTextToDisplay,
                            refForm,
                            onFinishFailed,
                            infoOfOrder,
                            egovReason,
                            egovDeclineOtherReason
                          }: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('admissionNotes');

  const {profile:{userProfile}, admission:{collegeAndExecutor}} = useSelector(selectStore);

  async function signXml(xml:any, keyType = 'SIGNATURE') {
    // @ts-ignore
    const ncalayerClient = new NCALayerClient();



    try {
      await ncalayerClient.connect();
    } catch (error) {
      alert('Не удалось подключиться к NCALayer');
      handleStop();
      return null;
    }
    let activeTokens;
    try {
      activeTokens = await ncalayerClient.getActiveTokens();
    } catch (error) {
      handleStop();
      // console.error(error.toString());
      return null;
    }

    /**
     *  correctSign - Новое подписание, можно много-чего поставить, ссылка на доку - [https://github.com/sigex-kz/ncalayer-js-client/blob/master/API.md](дока)
     */
    let correctSign;

    try {
      // @ts-ignore
      correctSign = await ncalayerClient.basicsSignXML(
        // @ts-ignore
        window.NCALayerClient.basicsStorageAll,
        xml,
        // @ts-ignore
        window.NCALayerClient.basicsXMLParams,
        // @ts-ignore
        //todo:КОСТЫЛЬ
        ((userProfile?.data && userProfile?.data?.id == 1360278 || userProfile?.data && userProfile?.data?.id == 1390205 || userProfile?.data && userProfile?.data?.id == 10055) ? window.NCALayerClient.basicsSignerSignPerson : window.NCALayerClient.basicsSignerSignOrg)
      )
    } catch (error) {
      handleStop();
      return null;
    }

    return correctSign[0];
  }

  const signEgovXmlDoc = () => {
    handleStart()
    setTextToDisplay('Генерация egov xml...')

    const formData = new FormData as any;

    formData.append('id', infoOfOrder.data && infoOfOrder.data.educationOrder.id);
    formData.append('status', egovReason);
    formData.append('reason', egovDeclineOtherReason);

    axiosConfigOld.post(`/eds/get-xml-message`, new URLSearchParams(formData)).then(res => {

      return res.data;
    }).then(xmlEgovDocResult => {

      setTextToDisplay('Подписание egov расписки...')

      const signedEgovXmlDoc = signXml(xmlEgovDocResult, keyType);

      signedEgovXmlDoc.then((signedEgovXmlDocResult:any) => {
        if (signedEgovXmlDocResult) {

          const formDataToEgov = new FormData;
          formDataToEgov.append('id', infoOfOrder.data && infoOfOrder.data.educationOrder.id);
          formDataToEgov.append('xml', signedEgovXmlDocResult);

          axiosConfigOld.post(`/eds/save-message`, new URLSearchParams(formDataToEgov as any)).then(res => {
            console.info('res', res);
            message.success('Egov signature success');
            signXmlDoc()
          }, error => {
            handleStop();
            console.error(error)
          })

        } else {
          handleStop();
        }
      })
    })
  };

  function signXmlDoc() {
    handleStart();
    setTextToDisplay('Генерация документа...');
    axiosConfigOld.post(`/eds/generate-xml-doc`, new URLSearchParams(dataForXml), {
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    }).then(({data}) => data).then(
      xmlDocResult => {
        setTextToDisplay('Проверка подписи...');
        // console.log(xmlDocResult);
        const signedXmlDoc = signXml(xmlDocResult.xmlDoc, keyType);
        signedXmlDoc.then(signedXmlDocResult => {
          // console.log(signedXmlDocResult);
          if (signedXmlDocResult) {
            axiosConfigOld.post(`/eds/verify-signed-xml-doc`, new URLSearchParams({ signedXmlDoc: signedXmlDocResult }), {
              headers: { "Content-Type": "application/x-www-form-urlencoded" }
            }).then(({data}) => data).then(
              verifyResult => {
                setTextToDisplay('Генерация расписки...');
                tplData.qrImages = '';
                verifyResult.qrImages.forEach((qrImage:any, idx:any) => tplData.qrImages += `<img style="width: 120px; height: 120px" src="${qrImage}">`);

                const dataFromApi = {
                  signedXmlDoc: signedXmlDocResult,
                  personData: JSON.stringify(verifyResult.personData),
                  personDataObject: verifyResult.personData,
                  tplName: tplName,
                  tplData: JSON.stringify(tplData)
                };

                const verify = dataFromApi?.personDataObject?.code === userProfile?.data?.iin;

                if(verify){
                  axiosConfigOld.post(`/eds/generate-pdf2`, new URLSearchParams(dataFromApi), {
                    headers: { "Content-Type": "application/x-www-form-urlencoded" }
                  }).then(({data}:any) => data).then(
                    (generatePdf2Result:any) => {
                      handleStop();
                      edsResultHandler({ ...verifyResult, ...generatePdf2Result });


                    },
                    (error:any) => {
                      handleStop();
                      console.error(error)
                    }
                  );

                  infoOfOrder && infoOfOrder.data && infoOfOrder.data.educationOrder.selectedSpecialities.map((item:any) => {
                    // @ts-ignore
                    dispatch(fetchSetSpecialityStatusAction({
                      id: item.id,
                      status: 32
                    }))
                  })
                } else {
                  handleStop();
                  message.error('ИИН исполнителя не совпадает с ИИНом в использованной ЭЦП')
                }
              },
              (error:any) => {
                handleStop();
                console.error(error)
              }
            );
          }
        });
      },
      (error:any) => {
        handleStop();
        console.error(error);
      }
    );
    setTimeout(() => {
      handleStop();
    }, 240000);
  }

  return <StyledButton className={`${disabled ? 'disabled-btn' : ''}`} disabled={disabled} onClick={() => {
    refForm.validateFields()
      .then((values:any) => {
        if(infoOfOrder.data && infoOfOrder.data.educationOrder.source === '1'){
          signEgovXmlDoc()
        } else {
          signXmlDoc()
        }
      })
      .catch((error:any) => {
        onFinishFailed(error)
      })
  }
  } type="primary" icon={<IconKey/>}>
    {t("edsButtonTitle")}</StyledButton>;
}